import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { s3PublicUpload } from "../libs/awsLib";
import { useAppContext } from "../libs/contextLib";
import Button from 'react-bootstrap/Button';
import Col from "react-bootstrap/Col";
import Form from 'react-bootstrap/Form';
import ImageBusiness from '../components/ImageBusiness';
import InfoIcon from '../components/InfoIcon';
import "./Story.css";
import config from '../config';
import { onError } from "../libs/errorLib";
import { saveBusiness } from "../services/Business";
import { useLoader } from '../context/LoaderContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Story() {
    const { isAuthenticated } = useAppContext();
    const { business, setBusiness, stampsImageList } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();
    const [story, setStory] = useState("");
    const [storyExample, setStoryExample] = useState("");
    const [businessImageUrl, setBusinessImageUrl] = useState("");
    const [businessImageBlob, setBusinessImageBlob] = useState("");
    const [facebookUrl, setFacebookUrl] = useState("");
    const [instagramUrl, setInstagramUrl] = useState("");
    const maxWordsCount = 50;
    const [,setLoading] = useLoader();

    //var story = placeHolderText;
    var storyPlaceholder = "Example - Inspired by my mom's Korean beauty rituals, I created Savor Beauty, an easy numbered natural skincare system. Made organically in New York, the collection is used in our 3 award-winning spas and by nationwide spa partners. My mission is for women to savor self-care every day.";
    
    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading, setLoading]);

    useEffect(() => {
        //ensures window scrolls to top when loading this page
        window.scrollTo(0, 0);
        
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }
            setIsLoading(true);

            //initialize story to the business information in appContext
            setStory(business.story);
            if (business.story) {
                setStoryExample(business.story);
            } else {
                setStoryExample(storyPlaceholder);
            }

            if (business && business.businessImageUrl) {
                //break cache since we need to edit the image
                var randomNum = new Date().getTime();
                let blob = await fetch(business.businessImageUrl+"?"+randomNum).then(r => r.blob());
                setBusinessImageBlob(blob);
            }

            setBusinessImageUrl(business.businessImageUrl);
            setFacebookUrl(business.facebookUrl);
            setInstagramUrl(business.instagramUrl);
            setIsLoading(false);
        }

        onLoad();
    }, [business, isAuthenticated, storyPlaceholder]);

    function updateStory(value) {
        setStory(value);
        if (value && value !== '') {
            setStoryExample(value);
        } else {
            setStoryExample(storyPlaceholder);
        }
    }

    function validateForm() {
        return story && story.length > 0 && (wordsRemaining() >= 0);
    }

    const handleStoryKeyPress = (e) => {
        if (wordsRemaining() > 0) {
            //If more words are remaining, allow user to keep typing
        } else {
            //No more words available, prevent typing
            e.preventDefault();
            e.stopPropagation();
        }
    }

    function wordsRemaining() {
        var str = story;

        if (!str) return maxWordsCount;
        str = str.replace(/\n/g,' '); // newlines to space
        str = str.replace(/(^\s*)|(\s*$)/gi,''); // remove spaces from start + end
        str = str.replace(/[ ]{2,}/gi,' '); // 2 or more spaces to 1
        const wordCount = str.split(' ').length;
        return maxWordsCount - wordCount;
    }

    async function handleSubmit(event, destination) {
        event.preventDefault();
        event.stopPropagation();

        setIsLoading(true);
        try {
            const params = {};

            //check if any data needs to be saved.  If not, no need to do an extra call to save
            let hasChanges = false;
            if (story !== business.story) {
                params["story"] = story;
                hasChanges = true;
            }
            if (businessImageUrl !== business.businessImageUrl) {
                params["businessImageUrl"] = businessImageUrl;
                hasChanges = true;
            }
            if (facebookUrl !== business.facebookUrl) {
                params["facebookUrl"] = facebookUrl;
                hasChanges = true;
            }
            if (instagramUrl !== business.instagramUrl) {
                params["instagramUrl"] = instagramUrl;
                hasChanges = true;
            }

            //Saving a call to backend unless there are changes
            if (hasChanges) {
                await saveBusiness(business.businessId, params);

                //update business stored in appContext once save is successful
                //also saving a call to refresh business object (for now) since changes are easy to track
                business.story = story;
                business.businessImageUrl = businessImageUrl;
                business.facebookUrl = facebookUrl;
                business.instagramUrl = instagramUrl;
                setBusiness(business);
            }
            setIsLoading(false);

            //go to destination
            if (destination === "back") {
                history.push("sticker");
            } else if (destination === "next") {
                history.push("stamps");
            } else if (destination === "home") {
                history.push("home");
            } 
        } catch (e) {
            onError(e);
            setIsLoading(false);
        }
    }

    async function setBusinessImage(output) {
        const s3FileName = output.file ? await s3PublicUpload(output.file) : null;
        
        //TODO: Storing the full S3 path right now for easier retrieval.  need to look for better practices
        const imageFullUrl = "https://" + config.s3.BUCKET + ".s3.amazonaws.com/public/" + s3FileName;
        setBusinessImageUrl(imageFullUrl);
    };

    return (
        <div className="content">
            {isAuthenticated && !isLoading && (
                <div className="story">
                    <div className="contentHeader row-bottom-20">
                        <div>
                            <h2>2. Share Your Story</h2>
                            <h4>Create a profile in our Sertify Directory with a photo of you and/or your business, along with a 50-word story.</h4>
                        </div>
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <div className="contentBody">
                            <div className="left-text row-bottom-10">
                                2a. Upload or take a photo of you and/or your business (optional)
                            </div>
                            <div>
                                <ImageBusiness 
                                    setImageObject={setBusinessImage} 
                                    imageSrc={businessImageBlob} 
                                    backgroundSrc={"https://sert-consumer.s3.amazonaws.com/images/window.png"} 
                                    story={storyExample}
                                    stickers={stampsImageList}
                                />
                            </div>
                        </div>
                        <div className="contentBody">
                            <div className="left-text row-bottom-10">
                                2b. Tell us your story 
                                { //If story word count exceeds maxmium allowed, show error 
                                    wordsRemaining() < 0 && (
                                        <><span className="warning">&nbsp;&nbsp;Please use {maxWordsCount} words or less</span></>
                                    )
                                }
                            </div>
                            <div>
                                <Form.Group controlId="story">
                                    <Form.Control
                                        value={story}
                                        as="textarea"
                                        rows="4"
                                        placeholder="up to 50 words"
                                        onChange={e => updateStory(e.target.value)}
                                        onKeyPress={handleStoryKeyPress}
                                    />
                                    {
                                        /* only show subscript if story has at least one word */
                                        story && story.length > 0 && (
                                            <div className="subscript left-text">{wordsRemaining()} words remaining (up to {maxWordsCount} words)</div>
                                        )
                                    }      
                                    <Form.Control.Feedback type="invalid">Please enter your business name</Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </div>
                        <div className="contentBody">
                            <div className="left-text row-bottom-10">
                                2c. Provide links to tag you in our social media posts (optional)
                                <InfoIcon 
                                    keyName={"socialMedia"}
                                    message={"At times, we profile small businesses in our social media posts."}
                                />
                            </div>
                            <div className="contentSocial row-bottom-20">
                                <div className="contentSocial-logo">
                                    <FontAwesomeIcon icon={['fab', 'facebook']} size="3x"></FontAwesomeIcon>
                                </div>
                                <div className="contentSocial-child">
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="facebookUrl">
                                            <Form.Control 
                                                value={facebookUrl}
                                                type="text" 
                                                size="sm"
                                                inputMode="url"
                                                onChange={e => setFacebookUrl(e.target.value)} />
                                            <Form.Label>Facebook Link</Form.Label>
                                        </Form.Group>
                                    </Form.Row>
                                </div>
                            </div>
                            <div className="contentSocial">
                                <div className="contentSocial-logo">
                                    <FontAwesomeIcon icon={['fab', 'instagram']} size="3x"></FontAwesomeIcon>
                                </div>
                                <div className="contentSocial-child">
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="instagramUrl">
                                            <Form.Control 
                                                value={instagramUrl}
                                                type="text" 
                                                size="sm"
                                                inputMode="url"
                                                onChange={e => setInstagramUrl(e.target.value)} />
                                            <Form.Label>Instagram Link</Form.Label>
                                        </Form.Group>
                                    </Form.Row>
                                </div>
                            </div>
                        </div>
                        {   //show Back/Next buttons if user is going through onboarding for first time
                            !business.onboardingCompletionDate && (
                            <div className="pageButtons-multiple row-top-10">
                                <Button variant="secondary" onClick={event => handleSubmit(event, 'back')} disabled={!validateForm()}>BACK</Button>
                                <Button variant="primary" onClick={event => handleSubmit(event, 'next')}  disabled={!validateForm()} >NEXT</Button>
                            </div>
                        )}
                        { /* User has completed onboarding.  Show "Save" button instead of "Next" */
                            business.onboardingCompletionDate && (
                            <div className="pageButtons-single row-top-10">
                                <Button variant="primary" onClick={event => handleSubmit(event, 'home')} disabled={!validateForm()}>SAVE</Button>
                            </div>
                        )}
                    </Form>
                </div>
            )}
        </div>
    );
}